// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"e008c351","213":"100e8bce","239":"384e8451","453":"6454df4e"}[chunkId] + ".chunk.js";
};